import React from 'react';
import { render } from 'react-dom';
import GlobalNav from './Component';
import CurrentUser from '@get-bridge/learn-legacy-shared/dist/entities/CurrentUser';
import ajaxInitializer from '../../config/initializers/ajax';
import ajax from '@get-bridge/learn-legacy-shared/dist/utils/ajax';

function renderGlobalNav(element, appInfo) {
  render(
    <GlobalNav appInfo={appInfo} pathname={window.location.pathname} />,
    element,
  );
}

// this is awful but we need it here until Learn is fully on Tapestry
// in other apps' initializers, a different bundle's Ajax gets initialized and
// it's possible (though only in certain cases) for this bundle (read:
// learnRuntime) to have an uninitialized Ajax adapter at this point
// we check here if it's set and set it if not, so global nav is happy
function setAjaxAdapterUnlessSet(callback) {
  if (!ajax.__isAdapterSet__()) {
    ajaxInitializer().initialize(callback);
  } else {
    callback();
  }
}

export default function initGlobalNav(element, appInfo, router) {
  setAjaxAdapterUnlessSet(() => {
    router.listen(() => {
      renderGlobalNav(element, appInfo);
    });
    CurrentUser.addChangeListener(() => {
      renderGlobalNav(element, appInfo);
    });
    renderGlobalNav(element, appInfo);
  });
}




// WEBPACK FOOTER //
// ./jsapp/learnRuntime/GlobalNav/index.js